<button
  mat-icon-button
  matTooltipPosition="above"
  ixTest="copy-to-clipboard"
  [matTooltip]="'Copy to Clipboard' | translate"
  (click)="copyToClipboard()"
>
  <ix-icon name="assignment"></ix-icon>
</button>
